import styled, { keyframes } from "styled-components";

const fadeIn = keyframes` from { opacity: 0; } to { opacity: 1; } `;
const slideIn = keyframes` from { transform: translateY(24px) scale(0.98); opacity: 0; } to { transform: translateY(0) scale(1); opacity: 1; } `;
const shine = keyframes` 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } `;

export const WarningOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 8, 20, 0.96);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12000;
  padding: 24px;
  box-sizing: border-box;
  animation: ${fadeIn} 0.3s ease-in-out;

  @media (max-width: 600px) {
    padding: 14px;
    align-items: flex-start;
    overflow-y: auto;
  }
`;

export const WarningContainer = styled.div`
  position: relative;
  background: linear-gradient(160deg, #ffffff 0%, #fdfaf0 100%);
  border-radius: 24px;
  border: 1px solid rgba(212, 175, 55, 0.5);
  overflow: hidden;
  box-sizing: border-box;
  max-width: 800px;
  width: 100%;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.45);
  animation: ${slideIn} 0.5s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 600px) {
    border-radius: 18px;
    margin: auto;
    max-height: none;
  }
`;

export const TopAccent = styled.div`
  height: 6px;
  width: 100%;
  flex-shrink: 0;
  background: linear-gradient(
    90deg,
    #b8860b,
    #f5d76e,
    #d4af37,
    #f5d76e,
    #b8860b
  );
  background-size: 200% 100%;
  animation: ${shine} 4s linear infinite;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 48px 20px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 600px) {
    padding: 28px 22px 16px;
  }
`;

export const IconCircle = styled.div`
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a1a1a, #000);
  border: 2px solid #d4af37;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  box-shadow: 0 8px 22px rgba(212, 175, 55, 0.25);

  svg {
    font-size: 34px;
    color: #f5d76e;
  }

  @media (max-width: 600px) {
    width: 64px;
    height: 64px;
    margin-bottom: 14px;

    svg {
      font-size: 28px;
    }
  }
`;

export const Badge = styled.span`
  background: linear-gradient(135deg, #d4af37, #b8860b);
  color: #fff;
  padding: 6px 20px;
  box-sizing: border-box;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 4px;
  text-transform: uppercase;
  box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
`;

export const Title = styled.h2`
  margin: 16px 0 0;
  font-size: 28px;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1.2;
  letter-spacing: 0.5px;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.h3`
  margin: 6px 0 0;
  font-size: 16px;
  font-weight: 700;
  color: #b8860b;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  @media (max-width: 600px) {
    font-size: 13px;
  }
`;

export const Divider = styled.div`
  width: 60px;
  height: 3px;
  border-radius: 3px;
  background: linear-gradient(90deg, #d4af37, #b8860b);
  margin: 14px auto 0;
`;

export const Assunto = styled.p`
  margin: 18px 0 0;
  font-size: 13.5px;
  color: #3a4250;
  line-height: 1.5;
  text-align: center;
  max-width: 620px;

  strong {
    color: #1a1a1a;
    font-weight: 800;
  }

  @media (max-width: 600px) {
    font-size: 12.5px;
    margin-top: 14px;
  }
`;

export const Body = styled.div`
  padding: 8px 48px 0;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 600px) {
    padding: 4px 22px 0;
    overflow-y: visible;
  }
`;

export const TextContent = styled.div`
  font-size: 16px;
  line-height: 1.75;
  color: #3a4250;
  text-align: justify;

  p {
    margin: 0 0 16px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    color: #b8860b;
    font-weight: 800;
  }

  @media (max-width: 600px) {
    font-size: 14.5px;
    line-height: 1.65;
    text-align: left;
  }
`;

export const Greeting = styled.p`
  font-weight: 700;
  color: #1a1a1a !important;
`;

export const SectionTitle = styled.h4`
  margin: 26px 0 12px;
  font-size: 17px;
  font-weight: 800;
  color: #1a1a1a;
  padding-left: 14px;
  border-left: 4px solid #d4af37;
  line-height: 1.35;

  @media (max-width: 600px) {
    font-size: 15px;
    margin: 22px 0 10px;
  }
`;

export const Highlight = styled.div`
  background: linear-gradient(
    135deg,
    rgba(212, 175, 55, 0.12),
    rgba(184, 134, 11, 0.06)
  );
  border: 1px solid rgba(212, 175, 55, 0.4);
  border-radius: 10px;
  padding: 16px 20px;
  margin: 4px 0 20px;
  font-size: 15.5px;
  line-height: 1.55;
  color: #1a1a1a;

  strong {
    color: #b8860b;
  }

  @media (max-width: 600px) {
    padding: 14px 16px;
    font-size: 14px;
  }
`;

export const Signature = styled.div`
  margin-top: 22px;
  font-size: 16px;
  line-height: 1.5;
  color: #3a4250;

  strong {
    display: block;
    color: #b8860b;
    font-weight: 800;
  }

  @media (max-width: 600px) {
    font-size: 14.5px;
    margin-top: 18px;
  }
`;

export const Footer = styled.div`
  padding: 28px 48px 36px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 600px) {
    padding: 22px 22px 28px;
  }
`;

export const AcceptButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #d4af37 0%, #b8860b 100%);
  color: #fff;
  padding: 18px 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.08);
    box-shadow: 0 12px 24px rgba(212, 175, 55, 0.35);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 600px) {
    padding: 16px 20px;
    font-size: 15px;
  }
`;
